import React from 'react'

import IcMap from '../../../../../../../../../assets/images/IcMap'
import IcMapActive from '../../../../../../../../../assets/images/IcMapActive'
import Input from '../../../../../../../../Control/Input'

const iconMap = {
    icon: IcMap,
    iconActive: IcMapActive,
    iconError: IcMapActive,
}

const InputLng = (valueInput) => {
    return (
        <Input
            name="lng"
            className="input-store"
            placeholder="Nhập Longitude"
            inputType="TEXT"
            value={valueInput.valueInput}
            onChange={valueInput.onChange}
            iconInput={iconMap}
        />
    )
}

export default InputLng
